<form [formGroup]="form">
  <div class="gap-lg flex flex-col" formArrayName="groupes">
    <app-resume-etape [etape]="etape()" />
    @for (control of groupesForm.controls; track $index; let idx = $index) {
      <app-expansion-panel [titre]="'Groupe ' + (idx + 1)" [isOpen]="true" [actions]="groupeActions()" [item]="idx">
        <app-chip
          class="ml-xxs"
          [label]="control.value.etat | convertEtatGroupeToString"
          [variant]="control.value.etat | getEtatGroupeVariant"
          ngProjectAs="chipRight"
        />
        <div class="px-lg pt-lg pb-xl" [formGroupName]="idx" hlmFieldGroup>
          <div hlmField>
            <label [for]="'select-section-nationale-' + idx" hlmLabel labelRequired>Section nationale</label>
            <hlm-select [id]="'select-section-nationale-' + idx" formControlName="sectionNationale">
              <hlm-select-trigger>
                <hlm-select-value />
              </hlm-select-trigger>

              <hlm-select-content>
                <hlm-option [value]="true">Oui</hlm-option>
                <hlm-option [value]="false">Non</hlm-option>
              </hlm-select-content>
            </hlm-select>
          </div>

          <div hlmField>
            <label [for]="'select-referentiel-' + idx" hlmLabel labelRequired>Métier</label>
            <hlm-select [id]="'select-referentiel-' + idx" formControlName="metiers" multiple>
              <hlm-select-trigger>
                <hlm-select-value />
              </hlm-select-trigger>

              <hlm-select-content>
                @for (referentiel of referentiels() | trierPar: 'nom'; track referentiel.id) {
                  <hlm-option [value]="referentiel.id">{{ referentiel.nom }}</hlm-option>
                }
              </hlm-select-content>
            </hlm-select>
          </div>

          <div class="gap-xs flex flex-col">
            <label [for]="'radio-group-annee-' + idx" labelRequired>Année</label>
            <hlm-radio-group [id]="'radio-group-annee-' + idx" formControlName="annee">
              <label class="flex items-center" [for]="'radio-1-' + idx" hlmLabel>
                <hlm-radio [id]="'radio-1-' + idx" [value]="1"><hlm-radio-indicator indicator /></hlm-radio>
                1ère année
              </label>
              <label class="flex items-center" [for]="'radio-2-' + idx" hlmLabel>
                <hlm-radio [id]="'radio-2-' + idx" [value]="2"><hlm-radio-indicator indicator /></hlm-radio>
                2ème année
              </label>
              <label class="flex items-center" [for]="'radio-3-' + idx" hlmLabel>
                <hlm-radio [id]="'radio-3-' + idx" [value]="3"><hlm-radio-indicator indicator /></hlm-radio>
                3ème année
              </label>
            </hlm-radio-group>
          </div>

          <div hlmField>
            <label [for]="'input-recrutes-max-' + idx" hlmLabel labelRequired>Nombre de recrutés maximum</label>
            <input
              [id]="'input-recrutes-max-' + idx"
              hlmInput
              formControlName="recrutesMaximum"
              type="number"
              inputmode="numeric"
            />
          </div>

          <div hlmField>
            <label [for]="'input-places-min-' + idx" hlmLabel labelRequired>Nombre de places minimum</label>
            <input
              [id]="'input-places-min-' + idx"
              hlmInput
              formControlName="placesMinimum"
              type="number"
              inputmode="numeric"
            />
          </div>

          <div hlmField>
            <label [for]="'input-places-max-' + idx" hlmLabel labelRequired>Nombre de places maximum</label>
            <input
              [id]="'input-places-max-' + idx"
              hlmInput
              formControlName="placesMaximum"
              type="number"
              inputmode="numeric"
            />
          </div>

          <div class="gap-md grid">
            <label class="flex items-center" hlmLabel><hlm-switch formControlName="capp" /> CAPP</label>
            <label class="flex items-center" hlmLabel><hlm-switch formControlName="ouvert" /> Ouvert</label>
          </div>

          <div hlmField>
            <label [for]="'select-publics-cibles-' + idx" hlmLabel>Publics Cibles</label>
            <hlm-select [id]="'select-publics-cibles-' + idx" formControlName="publicsCibles" multiple>
              <hlm-select-trigger>
                <hlm-select-value />
              </hlm-select-trigger>

              <hlm-select-content>
                @for (publicCible of publicsCibles(); track $index) {
                  <hlm-option [value]="publicCible">{{ publicCible }}</hlm-option>
                }
              </hlm-select-content>
            </hlm-select>
          </div>

          @if (
            groupesForm.at(idx).value.id &&
            (groupesForm.at(idx).value.etat === etatGroupe.A_FAIRE ||
              groupesForm.at(idx).value.etat === etatGroupe.REJETE)
          ) {
            <button (click)="envoyerGroupeAValidation(idx)" hlmBtn type="button" variant="secondary">
              Envoyer le groupe à validation
            </button>
          }
        </div>
      </app-expansion-panel>
    }

    @if (!readonly()) {
      <app-button-add-new (click)="ajouterGroupe()" label="Ajouter un groupe" />
    }
  </div>
</form>
